import { useAuth } from "./useAuth";
import {
  formatDateInTimezone,
  formatDateOnlyInTimezone,
  formatTimeOnlyInTimezone,
  convertToUTC,
  convertToUserTimezone,
  parseDateInTimezone,
  nowInTimezone,
  formatRelativeTime,
  getTimezoneAbbreviation,
} from "@/lib/timezones";

/**
 * Custom hook to get user's timezone and timezone-aware formatting functions
 */
export function useUserTimezone() {
  const { user } = useAuth();
  const userTimezone = user?.timezone || "UTC";

  return {
    timezone: userTimezone,
    // Existing formatting functions
    formatDate: (date: Date | string, options?: Intl.DateTimeFormatOptions) => 
      formatDateInTimezone(date, userTimezone, options),
    formatDateOnly: (date: Date | string) => 
      formatDateOnlyInTimezone(date, userTimezone),
    formatTimeOnly: (date: Date | string) => 
      formatTimeOnlyInTimezone(date, userTimezone),
    // New conversion functions
    convertToUTC: (date: Date | string) => 
      convertToUTC(date, userTimezone),
    convertToUserTimezone: (utcDate: Date | string) => 
      convertToUserTimezone(utcDate, userTimezone),
    parseDate: (dateString: string) => 
      parseDateInTimezone(dateString, userTimezone),
    now: () => 
      nowInTimezone(userTimezone),
    formatRelative: (date: Date | string) => 
      formatRelativeTime(date, userTimezone),
    getAbbreviation: () => 
      getTimezoneAbbreviation(userTimezone),
  };
}